import { MeetingSessionOvenMediaReceiver } from "@kalyzee/kast-web-sdk";
import { useRefAutoUpdate } from "@kalyzee/kast-web-sdk/web-components";
import { MeetingRoomAudienceType } from "@kalyzee/kast-web-sdk/websocket";
import { useEffect, useMemo } from "react";
import { usePageContext } from "../../../../../../components/navigation/PageContext";
import { ExpertsToRemotesContainer } from "../../../../../../components/player/container/ExpertsToRemotesContainer";
import { openMeetingActivityRoom, updateUserData } from "../../../../../../helpers/meeting";
import { useMeetingContainerAPI, useMeetingSelector } from "../../../../../../hooks/meeting";
import { useActivityData, useExpertAvailableViews, usePopulatedMeetingData } from "../../../../../../hooks/populatedData";
import { useUser } from "../../../../../../store/session/hooks";
import { SessionMode } from "../../../../../../store/session/slices";
import { usePedagogyContext } from "../../../context";
import styles from "./expert.module.css";
import { expertWebcamName, pedagogyWebcamName } from "../../../../../../helpers/webcam";




export const MeetingPedagogyInterventionExpertPage = () => {
  const pageContext = usePageContext<SessionMode.MASTER>();
  const pageContextRef = useRefAutoUpdate(pageContext);
  const meetingContainerAPI = useMeetingContainerAPI(pageContextRef.current?.params?.id);
  const pedagogyCtx = usePedagogyContext();
  const pedagogyCtxRef = useRefAutoUpdate(pedagogyCtx);
  const [meetingId] = useMeetingSelector(meetingContainerAPI, (state) => state.meeting?.id);

  const populatedMeetingData = usePopulatedMeetingData(meetingContainerAPI);
  const activityData = useActivityData(populatedMeetingData);
  const availableViews = useExpertAvailableViews(populatedMeetingData, activityData, pedagogyCtx?.spiedGroupId);

  const selfUser = useUser();

  const populatedData = usePopulatedMeetingData(meetingContainerAPI);

  const expertActivityView = useMemo(
    () => availableViews.find(v => v.type === "activity_pedagogy"), 
    [availableViews],
  );
  const expertSessions = useMemo(() => {
    return expertActivityView?.experts.filter(s => s.video).map(s => s.session) ?? [];
  }, [expertActivityView]);

  // ---------------------------------------------------------------------- //
  // ---------------------------   UTILS ----------------------------- //
  // ---------------------------------------------------------------------- //


  // ---------------------------------------------------------------------- //
  // ---------------------------   EFFECT ----------------------------- //
  // ---------------------------------------------------------------------- //

  useEffect(() => {
    const validator = pedagogyCtxRef.current?.addAudioValidator((session: MeetingSessionOvenMediaReceiver) => {
      const currSession = expertSessions.find((s) => s.videoSessions.find((v) => v === session));
      if (!currSession) return false;
      return session.data.mediaSession.name === expertWebcamName || session.data.mediaSession.name === pedagogyWebcamName;
    });
    return () => {
      validator?.flush();
    };
  }, [expertSessions]);

  useEffect(() => {
    if (!meetingId) return;
    if (!selfUser) return;  
    if (expertActivityView) return;
    const expertSos = populatedData?.expertUsers.filter(u => u.data?.sosMode);
    expertSos?.forEach(expert => {
      updateUserData(meetingId, { mode: "by_user_id", id: expert.id }, { sosMode: false });
    });
    openMeetingActivityRoom({ 
      id: meetingId, 
      audience: { type: MeetingRoomAudienceType.Custom, values: [] },
      preEnlistedUserIds: [selfUser.id],
      keepEnlistedUsersIfSameAudienceType: true,
    });
  }, [meetingId, expertActivityView]);
  
  // ---------------------------------------------------------------------- //
  // ---------------------------   RENDER ----------------------------- //
  // ---------------------------------------------------------------------- //

  if (!expertActivityView) {
    return (
      <div style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        width: "100%",
        color: "white",
      }}>
        En attente des experts ...
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <ExpertsToRemotesContainer
        meetingContainerAPI={meetingContainerAPI} 
        context={pedagogyCtx}
        remoteSessions={expertSessions}
        showSelf="current_video"
        webcamAndScreenOnly
      />
    </div>
  );
};
